module.exports = __webpack_public_path__ + "static/media/burger.ccfec962.svg";